export default __webpack_public_path__ + "static/media/mascot.30418523.png";